document.addEventListener("DOMContentLoaded", function() {
  function openTidioChat() {
    if (window.tidioChatApi) {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    }
  }

  function whenTidioReady(callback) {
    if (window.tidioChatApi) {
      callback();
    } else {
      document.addEventListener("tidioChat-ready", function handler() {
        document.removeEventListener("tidioChat-ready", handler);
        callback();
      });
    }
  }

  function handleTidioHash(force = false) {
    if (window.location.hash === "#tidio-chat" || force) {
      whenTidioReady(openTidioChat);
    }
  }

  // 1) On page load
  handleTidioHash();

  // 2) When hash actually changes
  window.addEventListener("hashchange", function() {
    handleTidioHash();
  });

  // 3) When clicking links with #tidio-chat, even if hash is the same
  document.addEventListener("click", function(e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, window.location.origin);

    if (url.hash === "#tidio-chat") {
      // Same page and same hash - hashchange will not fire
      if (url.pathname === window.location.pathname && window.location.hash === "#tidio-chat") {
        e.preventDefault();
        handleTidioHash(true); // force open
      }
    }
  });
});